<mat-nav-list>
  <a mat-list-item routerLink="/dashboard" (click)="onSidenavClose()">
    <mat-icon>home</mat-icon>
    <span class="nav-caption" i18n="Home|Parola Home@@HomesidenavListComp">Home</span>
  </a>
  <!--
  TODO Sistemare links sidenav
  -->
  <a mat-list-item routerLink="/shares" (click)="onSidenavClose()">
    <mat-icon>assignment_ind</mat-icon>
    <span class="nav-caption" i18n="Azioni Amministratore|Le Azioni @@AzioniAmministratoreSidenavListComp">Actions Amministratore</span>
  </a>
  <a mat-list-item routerLink="#" (click)="onSidenavClose()">
    <mat-icon>account_balance</mat-icon>
    <span class="nav-caption"
          i18n="Azioni Account|Le Azioni che l utente puo fare nel menu@@AzioniAccountSidenavListComp">Actions Account</span>
  </a>
  <mat-list-item [matMenuTriggerFor]="menu">
    <mat-icon>unfold_more</mat-icon>
    <a matline>Example</a>
  </mat-list-item>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onSidenavClose()">View profile</button>
    <button mat-menu-item (click)="onSidenavClose()">Add contact</button>
  </mat-menu>
</mat-nav-list>
